'use client';

import { Locale, CacheKeys } from '@headless-workspace/config';
import { Result } from '@headless-workspace/core-domain';
import useSWRMutation, { TriggerWithoutArgs } from 'swr/mutation';
import { CommonDI, UserCookiesRepositoryType } from '../../../DI';

type MutationTrigger = TriggerWithoutArgs<Result<boolean>, typeof CacheKeys.PotionCookie>;

type UsePotionCookieManagerReturn = {
    deletePotionCookie: MutationTrigger;
    setPotionCookie: MutationTrigger;
};

/**
 * Custom hook for managing potion cookies
 * @param locale - The locale for creating potion cookies
 * @returns Object containing loading state, cookie data, and mutation functions
 */
export const usePotionCookieManager = (locale: Locale): UsePotionCookieManagerReturn => {
    const { trigger: setPotionCookie } = useSWRMutation<Result<boolean>, typeof CacheKeys.PotionCookie>(
        CacheKeys.PotionCookie,
        () => CommonDI.get(UserCookiesRepositoryType).createPotionCookie(locale),
    );

    const { trigger: deletePotionCookie } = useSWRMutation<Result<boolean>, typeof CacheKeys.PotionCookie>(
        CacheKeys.PotionCookie,
        () => CommonDI.get(UserCookiesRepositoryType).deletePotionCookie(),
    );

    return {
        deletePotionCookie,
        setPotionCookie,
    };
};
